<template>
  <div id="chartdiv"></div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themesAnimated from '@amcharts/amcharts4/themes/animated';

/* Chart code */
am4core.options.queue = true;
// Themes begin
am4core.useTheme(am4themesAnimated);
am4core.addLicense('CH315878972');
// Themes end

export default {
  props: {
    id: {
      type: String,
      default: 'chartdiv',
    },
    height: {
      type: String,
      default: '100%',
    },
    width: {
      type: String,
      default: '100%',
    },
    colors: {
      type: Array,
      default: () => ['#f799d1', '#e04074'],
    },
    data: {
      type: Array,
      default: () => [],
    },
    yAxis: {
      type: Object,
      default: () => ({
        label: 'name',
      }),
    },
    xAxis: {
      type: Object,
      default: () => ({
        label: 'value',
      }),
    },
  },
  mounted() {
    const chartContainer = document.getElementById(this.id);
    chartContainer.style.width = this.width;
    chartContainer.style.height = this.height;
    // Create chart instance
    const chart = am4core.create('chartdiv', am4charts.XYChart);

    chart.data = this.data;

    chart.legend = new am4charts.Legend();
    chart.legend.position = 'bottom';
    chart.responsive.enabled = true;
    chart.responsive.useDefault = false;
    // Create axes
    const categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = this.xAxis.label;
    categoryAxis.numberFormatter.numberFormat = '####';
    categoryAxis.renderer.grid.template.opacity = 0;
    categoryAxis.renderer.fontWeight = 'bold';
    categoryAxis.renderer.minGridDistance = 30;

    const valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
    valueAxis.numberFormatter.numberFormat = '#.';
    valueAxis.renderer.grid.template.opacity = 0;
    valueAxis.renderer.ticks.template.strokeOpacity = 0;
    valueAxis.renderer.ticks.template.stroke = am4core.color('#fff');
    valueAxis.renderer.ticks.template.length = 10;
    valueAxis.renderer.line.strokeOpacity = 0;
    valueAxis.renderer.fillOpacity = 0;
    valueAxis.renderer.baseGrid.disabled = true;
    // valueAxis.renderer.minGridDistance = 20;

    // Create series
    function createSeries(field, name, color) {
      const series = chart.series.push(new am4charts.ColumnSeries());
      series.name = name;
      series.dataFields.valueX = field;
      series.dataFields.categoryY = 'Year';
      series.stacked = true;
      series.sequencedInterpolation = true;
      series.fill = am4core.color(color);

      series.columns.template.width = am4core.percent(60);
      series.columns.template.tooltipText = '{name}\n[bold font-size: 17px]{categoryY}: {valueX}[/]';

      const labelBullet = series.bullets.push(new am4charts.LabelBullet());
      labelBullet.locationX = 0.5;
      labelBullet.label.text = '{valueX}';
      labelBullet.label.fill = am4core.color('#fff');
      labelBullet.label.hideOversized = true;
    }

    createSeries('Slight casualties', 'Slight casualties', this.colors[0]);
    createSeries('Seriously injured', 'Seriously injured', this.colors[1]);
    createSeries('Fatalities', 'Fatalities', this.colors[2]);
  },
};
</script>

<style></style>
